<div class="o-wrapper">
    <div class="c-error-container -align-center">
        <div class="c-error-container__text">
            <h2>Sorry, er loopt iets mis</h2>
            <p>Door technische problemen kunnen we de pagina niet tonen. We lossen dit zo snel mogelijk op.
                Herlaad de pagina of probeer later opnieuw.
            </p>
        </div>
        <img class="c-error-container__img" src="https://cdn.vdab.be/img/templates/error.svg" alt="">
    </div>
</div>
